const { createSlice } = require("@reduxjs/toolkit");

const filterSlice=createSlice({
    name:'filter',
    initialState:{
        status:null,
    },
    reducers:{
        selectedStatus(state,action){
            state.status=action.payload
        },
    }
})

export const filterActions=filterSlice.actions;
export default filterSlice;